module.exports = __webpack_public_path__ + "static/media/sia-edu-learn.8bf2ef19.png";